import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/AdminLayout";
import { api } from "../../lib/api";

const TYPE_LABEL = {
  contact: "General",
  quote: "Custom quote",
  consultation: "Consultation",
  strategy_call: "Strategy call",
  newsletter: "Newsletter",
};

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/leads");
      setLeads(data);
      setLoading(false);
    })();
  }, []);
  return (
    <AdminLayout>
      <div className="eyebrow mb-2">Leads</div>
      <h1 className="font-display text-4xl font-bold tracking-tight">Inbox</h1>

      <div className="mt-6 rounded-2xl border border-line bg-white overflow-hidden">
        {loading ? (
          <div className="px-6 py-10 text-sm text-inkSoft">Loading…</div>
        ) : leads.length === 0 ? (
          <div className="px-6 py-10 text-sm text-inkSoft text-center">No leads yet.</div>
        ) : (
          <ul>
            {leads.map((l) => (
              <li key={l.lead_id} className="px-6 py-4 border-b border-line last:border-0 grid sm:grid-cols-12 gap-2 items-center">
                <div className="sm:col-span-3">
                  <div className="font-medium">{l.name}</div>
                  <div className="text-xs text-inkSoft">{l.email}</div>
                </div>
                <div className="sm:col-span-2">
                  <span className="tag">{TYPE_LABEL[l.type] || l.type}</span>
                </div>
                <div className="sm:col-span-5 text-sm text-ink/85 line-clamp-2">{l.message || <span className="text-inkSoft">No message</span>}</div>
                <div className="sm:col-span-2 text-right text-xs font-mono text-inkSoft">{new Date(l.created_at).toLocaleDateString()}</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </AdminLayout>
  );
}
